@use "@fukuri-admins/ui/layout" as *;

.Screen {
  display: flex;
  background-color: background('Primary');
  padding-left: $SideMenuWidth;
  min-height: 100vh;
  width: 100%;
  @media screen and (max-width: $TB) {
    flex-direction: column;
    padding-left: 0;
    padding-top: 40px;
  }
}

.ContentWrapper {
  flex: 1;
  min-width: 0;
  width: 100%;
}

.Content {
  padding: spacing('24');
  // DefaultLayoutHeaderの高さ分の調整
  height: calc(100% - 64px);
}
